import { render, staticRenderFns } from "./ProductTextLanguagesDialog.vue?vue&type=template&id=43f75096&scoped=true&lang=pug&"
import script from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f75096",
  null
  
)

export default component.exports